<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Shift Code</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Table List -->
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-2">
                        <h4 class="mt-2">Company</h4>
                    </div>
                    <div class="col-md-5 fit-content">
                        <select class="form-control" v-model="company" @change="changeCompany">
                            <option v-for="company in companies" :key="company.CompanyName"
                                :value="company.CompanyName">
                                {{ company.CompanyName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
                    <table style="width: auto !important" class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-center" style="width: 300px">Shift Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(code, i) in shiftCodes" :key="code.Id">
                                <td class="text-center" style="position: relative">
                                    <input type="text" v-model="code.Code" class="form-control height26 text-center"
                                        maxlength="30" required />
                                    <span @click="removeShiftCode(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>

                            <tr v-for="(newCode, i) in newShiftCodes" :key="i">
                                <td class="text-center" style="position: relative">
                                    <input type="text" v-model="newCode.Code" class="form-control height26 text-center"
                                        maxlength="30" required />
                                    <span @click="removeNewShiftCode(i)" style="
                                        position: absolute;
                                        right: -8px;
                                        top: 6px;
                                        color: #ff0000;
                                        cursor: pointer;">
                                        <i class="fa fa-minus-circle"></i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center" colspan="5">
                                    <button type="button" class="btn btn-primary" @click="addShiftCode">
                                        <i class="fa fa-plus"></i> Add Shift Code
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-4">
                    <div class="col-md-12">
                        <button @click="save" type="button" class="btn btn-primary">
                            <i class="fa fa-save"></i>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Table List -->
    </div>
</template>

<script>
import API from "../../http-common.js";
export default {
    data() {
        return {
            company: "Lam Research Singapore Pte Ltd",
            companies: [],
            shiftCodes: [],
            newShiftCodes: [],
        };
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },
    methods: {
        addShiftCode() {
            this.newShiftCodes.push({
                Id: "",
                Code: ""
            });
        },
        removeNewShiftCode(index) {
            this.newShiftCodes.splice(index, 1);
        },
        removeShiftCode(index) {
            this.shiftCodes.splice(index, 1);
        },
        changeCompany() {
            this.getShiftCodes();
        },
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                        this.company = this.companies[0].CompanyName;
                        this.getShiftCodes();
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getShiftCodes() {
            let param = {
                Token: this.token,
                Company: this.company,
            };
            this.$store.state.isLoading = true;
            API.getShiftCodes(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        if (response.data.record) this.shiftCodes = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            //check duplicate shift code
            let allShiftCodes = this.shiftCodes.concat(this.newShiftCodes);
            for (let item of allShiftCodes) {
                if (item.Code) {
                    let records = allShiftCodes.filter(
                        (c) => c.Code == item.Code
                    );
                    if (records && records.length > 1) {
                        alert(`Shift Code: ${item.Code} is duplicated.`);
                        return;
                    }
                }
            }

            let param = {
                Token: this.token,
                Company: this.company,
                ShiftCodes: this.shiftCodes,
                NewShiftCodes: this.newShiftCodes,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the shift code?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveShiftCodes(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            this.shiftCodes = [];
                            this.newShiftCodes = [];
                            this.getShiftCodes();
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
    },
    created() {
        if (this.role != "admin") this.$router.replace({ name: "home" });
        this.getCompanies();
    },
};
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/System/ShiftCode.vue